import { WEB_DEFAULT_TANKER, WEB_DEFAULT_CODE } from './rules';
class TankerRecognizer {
    constructor(options = {}) {
        this.autoDetect = options.autoDetect || false;
        this.userAgent = (options.userAgent || '').toLowerCase();
        this.rules = [];
        this.ruleAdopterPromise = null
    }

    ruleAdapte(promise) {
        if (!this.ruleAdopterPromise) {
            this.ruleAdopterPromise = typeof promise === 'function' ? 
                (this.rules = promise(), Promise.resolve(this.rules)) : typeof promise.then === 'function'?
                promise.then((rules) => {
                    this.rules = rules;
                    return this.rules;
                }):  (this.rules = promise, Promise.resolve(this.rules));
        }
        return this.ruleAdopterPromise
    }
    valideCommonRules(rule) {
        let dir = '+', v = '';
        if (Object.prototype.toString.call(rule) === '[object String]') {
          v = rule
        } else if (Array.isArray(rule)) {
          if (rule.length == 0) return true;
          if (rule.length == 2) {
            dir = rule[0];
            v = rule[1];
          } else if (rule.length == 1) {
            v = rule[0]
          }
        }   
        const reg = new RegExp(v.toLowerCase(), 'ig');
        const sug = dir == '+' ? true : false;
        const tested = reg.test(this.userAgent);
        return v == '' ? false : sug ? tested : !tested;
    }
    validRoot (rule) {
        const { rules: rootRules, code, app } = rule;
        const len = rootRules.length;
        for(let i = 0; i < len; i++) {
            if (!this.valideCommonRules(rootRules[i])) {
                return null;
            }
        }
        return {
            code,
            app
        }
    }
    validSubterm(subRules = []) {
        if (!subRules || subRules.length == 0) {
            return false;
        }
        for(let si = 0 ; si < subRules.length; si++) {
            if (!this.valideCommonRules(subRules[si])) {
               return false;
            }
        }
        return true;
    }
    validSubterms(rules = []) {
        const len = rules.length;
        if (len < 1) {
            return null;
        }
        for(let i = 0; i < len; i++) {
            const rootRule = rules[i];
            const { rules: subRules, app: subApp, weight } = rootRule;
            if (this.validSubterm(subRules)) {
                return {
                    app: subApp,
                    code: weight? weight : (TankerRecognizer['Weight_' + subApp.toUpperCase()] || 0)
                }
            }
        }
       return null;
    }
    memberized(validRootRes, validSubRes) {
        if (!validRootRes) {
            return {
                code: WEB_DEFAULT_CODE,
                app: WEB_DEFAULT_TANKER
            };
        }
        const { app: rootApp, code: rootCode} = validRootRes;
        if (!this.__cached) {
            this.__cached = {
                app: validSubRes && validSubRes.app ? [rootApp, validSubRes.app].join('.') : rootApp,
                code: validSubRes && validSubRes.app && validRootRes.code ? Number(rootCode) + Number(validSubRes.code) : Number(rootCode)
            }
        }
        return this.__cached;
    }
    match() {
        const rules = this.rules, len = rules.length;
        let validRootRes = null , validSubRes = null;
        for(let index = 0; index < len; index++ ) {
            const rootRule = rules[index];
            validRootRes = this.validRoot(rootRule);
            if (validRootRes) {
                validSubRes = rootRule.subterms ? this.validSubterms(rootRule.subterms) : null
                break;
            }
        }
        return this.memberized(validRootRes, validSubRes);
    }
}
TankerRecognizer.Weight_MINI = 1;

export default TankerRecognizer;